import { InputNumber } from "antd";

type Props = {
  size?: "small" | "middle" | "large";
  variant?: "borderless" | "outlined" | "filled";
  value?: number;
  onChange?: ((value: number | null) => void) | undefined;
  readOnly?: boolean;
  disabled?: boolean;
  calculatePercentage?: boolean;
};

export const PercentageInput = ({
  size,
  variant,
  onChange,
  value,
  readOnly,
  disabled,
  calculatePercentage = false,
}: Props) => {
  return (
    <InputNumber
      value={value}
      formatter={(v) => `${calculatePercentage ? (v ?? 0) * 100 : v} %`}
      parser={(v) => v?.replace(" %", "") as unknown as number}
      size={size}
      variant={variant}
      onChange={onChange}
      readOnly={readOnly}
      disabled={disabled}
    />
  );
};
